import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import TopicBanner from './TopicBanner';
import TopicSummary from './TopicSummary';
import { topicJuniorAccountantImgs } from '../../images/topicImg';
import StyleThreeCurriculum from '../style-three/StyleThreeCurriculum';
import {
  SummaryJuniorAccountantData,
  CurriculumJuniorAccountantList,
} from '../../utils/tools/publicParams';
export class JuniorAccountant extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  onMeiQiaCustomer() {
    window._MEIQIA('showPanel');
  }
  render() {
    return (
      <div className="topic-junior-accountant">
        {/* 专题Banner */}
        <TopicBanner url={topicJuniorAccountantImgs.Banner_bg} />
        {/* 汇总统计行 */}
        <TopicSummary SummaryData={SummaryJuniorAccountantData} ContentColor={'#1d74de'} />
        {/* 课程体系 - 版本三 */}
        <StyleThreeCurriculum
          itemsData={CurriculumJuniorAccountantList}
          onMeiQiaCustomer={this.onMeiQiaCustomer.bind(this)}
          ActiveColor={'#1d74de'}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JuniorAccountant);



// WEBPACK FOOTER //
// ./src/features/topic/JuniorAccountant.js